import styled from "styled-components";
import { fHeader, fBodySm } from "../../styles/global";

export const Title = styled.h1`
  ${fHeader}
  margin-bottom: 4.6rem;

  > div {
    ${"" /* max-width: 38rem; */}
  }
`;

export const WorksList = styled.div`
  border-top: 1px solid black;
  padding-top: 1.3rem;
`;

export const Work = styled.div`
  ${"" /* width: ${props => (props.portrait ? "82%" : "auto")}; */}

  & + div {
    margin-top: 4.6rem;
  }
`;

export const ImageSizer = styled.div`
  max-width: 100%;
`;

export const WorkInfo = styled.div`
  margin-top: 1.3rem;
  ${"" /* max-width: 25rem; */}

  em {
    font-style: italic;
  }
`;

export const DownloadLink = styled.div`
  margin-top: 1.3rem;
  a {
    ${fBodySm}
  }

  a:hover {
    opacity: 0.5;
  }
`;
